import set from "lodash/set";

const checklistInit = {
  open: false,
  pinned: false,
  data: null, // {}
  state: null, // {}
  templates: null, // []
  showTemplates: false,
  showHistory: false,
  showComments: false,
  taskListId: null,
};

const initState = {
  open: false,
  type: null,
  state: null,
  params: null,
  //fetches
  checklist: checklistInit,
  loanTerms: null,
};

const navSidebarReducer = (state = initState, action) => {
  // Create a shallow copy to modify
  let newState = { ...state };

  switch (action.type) {
    case "SET_SIDEBAR":
      return action.payload;

    case "TOGGLE_SIDEBAR":
      newState.open = !newState.open;
      return newState;

    case "OPEN_SIDEBAR":
      return {
        ...newState,
        open: true,
        type: action.payload?.type ?? newState.type,
        state: action.payload?.state ?? newState.state,
        params: action.payload?.params ?? newState.params,
      };
    case "CLOSE_SIDEBAR":
      newState.open = false;
      return newState;

    case "SET_SIDEBAR_KEY":
      return set(newState, action.payload.key, action.payload.value);

    case "CLEAR_SIDEBAR":
      let clearedState = { ...initState };
      clearedState.checklist = state.checklist; // Preserve checklist on clear
      return clearedState;

    case "RESET_SIDEBAR":
      return initState;

    case "SET_SIDEBAR_TYPE":
      newState.type = action.payload;
      return newState;

    case "CLEAR_SIDEBAR_TYPE":
      newState.type = null;
      return newState;

    case "SET_SIDEBAR_STATE":
      newState.state = action.payload;
      return newState;

    case "SET_SIDEBAR_PARAMS":
      newState.params = action.payload;
      return newState;

    case "SET_SIDEBAR_CHECKLIST":
      newState.checklist = action.payload;
      return newState;

    case "CLEAR_SIDEBAR_CHECKLIST":
      newState.checklist = checklistInit;
      return newState;

    case "SET_SIDEBAR_CHECKLIST_OPEN":
      newState.checklist = {
        ...newState.checklist,
        open: action.payload,
      };
      return newState;

    case "SET_SIDEBAR_CHECKLIST_DATA":
      newState.checklist = {
        ...newState.checklist,
        data: action.payload,
      };
      return newState;

    case "SET_SIDEBAR_CHECKLIST_STATE":
      newState.checklist = {
        ...newState.checklist,
        state: action.payload,
      };
      return newState;

    case "SET_SIDEBAR_CHECKLIST_TEMPLATES":
      newState.checklist = {
        ...newState.checklist,
        templates: action.payload,
      };
      return newState;

    case "TOGGLE_SIDEBAR_CHECKLIST_OPEN":
      newState.checklist = {
        ...newState.checklist,
        open: !newState.checklist?.open,
      };
      return newState;

    case "TOGGLE_SIDEBAR_CHECKLIST_TOGGLE_SHOW_TEMPLATES":
      newState.checklist = {
        ...newState.checklist,
        showTemplates: !newState.checklist?.showTemplates,
      };
      return newState;

    case "TOGGLE_SIDEBAR_CHECKLIST_SHOW_TEMPLATES":
      newState.checklist = {
        ...newState.checklist,
        showTemplates: true,
      };
      return newState;

    case "TOGGLE_SIDEBAR_CHECKLIST_HIDE_TEMPLATES":
      newState.checklist = {
        ...newState.checklist,
        showTemplates: false,
      };
      return newState;

    case "TOGGLE_SIDEBAR_CHECKLIST_SHOW_COMMENTS":
      newState.checklist = {
        ...newState.checklist,
        showComments: true,
      };
      return newState;

    case "TOGGLE_SIDEBAR_CHECKLIST_HIDE_COMMENTS":
      newState.checklist = {
        ...newState.checklist,
        showComments: false,
      };
      return newState;

    case "TOGGLE_SIDEBAR_CHECKLIST_TOGGLE_SHOW_HISTORY":
      newState.checklist = {
        ...newState.checklist,
        showHistory: !newState.checklist?.showHistory,
      };
      return newState;

    case "TOGGLE_SIDEBAR_CHECKLIST_SHOW_HISTORY":
      newState.checklist = {
        ...newState.checklist,
        showHistory: true,
      };
      return newState;

    case "TOGGLE_SIDEBAR_CHECKLIST_HIDE_HISTORY":
      newState.checklist = {
        ...newState.checklist,
        showHistory: false,
      };
      return newState;

    case "TOGGLE_SIDEBAR_CHECKLIST_PINNED":
      newState.checklist = {
        ...newState.checklist,
        pinned: !newState.checklist?.pinned,
      };
      return newState;

    case "SET_SIDEBAR_CHECKLIST_ID":
      newState.checklist = {
        ...newState.checklist,
        taskListId: action.payload,
      };
      return newState;

    case "CLEAR_SIDEBAR_STATE":
      newState.state = null;
      return newState;

    case "SET_SIDEBAR_VALUES":
      // Payload should be an object like { name, state, open, ... }
      return {
        ...newState,
        ...action.payload,
      };

    case "TOGGLE_SIDEBAR_TYPE":
      // If current type matches the payload, set it to null; otherwise set it to the payload
      newState.type = newState.type === action.payload ? null : action.payload;
      return newState;

    default:
      return state;
  }
};

export const sidebarOpen = (type = null, state = null, params = null) => ({
  type: "OPEN_SIDEBAR",
  payload: { type, state, params },
});

export const sidebarChecklistSetOpen = (open) => ({
  type: "SET_SIDEBAR_CHECKLIST_OPEN",
  payload: open,
});

export const sidebarChecklistSetData = (data) => ({
  type: "SET_SIDEBAR_CHECKLIST_DATA",
  payload: data,
});

export const sidebarChecklistSetId = (id) => ({
  type: "SET_SIDEBAR_CHECKLIST_ID",
  payload: id,
});

export const sidebarChecklistClearId = () => ({
  type: "SET_SIDEBAR_CHECKLIST_ID",
  payload: null,
});

export const sidebarChecklistSetTemplates = (templates) => ({
  type: "SET_SIDEBAR_CHECKLIST_TEMPLATES",
  payload: templates,
});

export const sidebarChecklistToggleOpen = () => ({
  type: "TOGGLE_SIDEBAR_CHECKLIST_OPEN",
});

export const sidebarChecklistToggleShowTemplates = () => ({
  type: "TOGGLE_SIDEBAR_CHECKLIST_TOGGLE_SHOW_TEMPLATES",
});

export const sidebarChecklistShowTemplates = () => ({
  type: "TOGGLE_SIDEBAR_CHECKLIST_SHOW_TEMPLATES",
});

export const sidebarChecklistHideTemplates = () => ({
  type: "TOGGLE_SIDEBAR_CHECKLIST_HIDE_TEMPLATES",
});

export const sidebarChecklistToggleShowHistory = () => ({
  type: "TOGGLE_SIDEBAR_CHECKLIST_TOGGLE_SHOW_HISTORY",
});

export const sidebarChecklistShowHistory = () => ({
  type: "TOGGLE_SIDEBAR_CHECKLIST_SHOW_HISTORY",
});

export const sidebarChecklistShowComments = () => ({
  type: "TOGGLE_SIDEBAR_CHECKLIST_SHOW_COMMENTS",
});

export const sidebarChecklistHideComments = () => ({
  type: "TOGGLE_SIDEBAR_CHECKLIST_HIDE_COMMENTS",
});

export const sidebarChecklistHideHistory = () => ({
  type: "TOGGLE_SIDEBAR_CHECKLIST_HIDE_HISTORY",
});

export const sidebarChecklistTogglePinned = () => ({
  type: "TOGGLE_SIDEBAR_CHECKLIST_PINNED",
});

export default navSidebarReducer;
